<app-navbar />
<router-outlet />
